import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'

// components
import {
  EntityAttribute,
  EntityBadge,
  EntityComment,
  EntityDeal,
  EntityHighlight,
  EntityOwnership,
  TagInput,
  TopBuys,
  TopSells
} from '../../../components'
import { ENTITY_TYPE } from '../../../utils'

const propTypes = {
  dataIdPrefix: PropTypes.string.isRequired,
  fund: PropTypes.object.isRequired,
  targetId: PropTypes.string,
  hasActiveDeal: PropTypes.bool,
  deals: PropTypes.shape({
    isLoading: PropTypes.bool,
    deals: PropTypes.array,
    pipeline: PropTypes.array
  }).isRequired,
  onDealSaveSuccess: PropTypes.func.isRequired
}

const defaultProps = {
  dataIdPrefix: 'FundPage',
  fund: {},
  hasActiveDeal: false,
  deals: {}
}

const { FUND } = ENTITY_TYPE

/**
 * Fund Overview Component
 * @param props
 */
function FundOverview (props) {
  const { dataIdPrefix, fund, targetId, hasActiveDeal, deals, onDealSaveSuccess } = props
  const { id, portfolioValue, equityAUM } = fund

  return (
    <div className='overview-layout'>
      <Grid container spacing={3}>
        <EntityBadge
          dataId={dataIdPrefix}
          data={{
            targetId,
            hasActiveDeal
          }}
        />
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <EntityAttribute
                dataId={dataIdPrefix}
                entityId={id}
                entityType={FUND}
                data={{
                  aum: portfolioValue,
                  equityAUM
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <EntityHighlight
                dataId={dataIdPrefix}
                entityId={id}
                entityType={FUND}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={8}>
              <EntityOwnership
                dataId={dataIdPrefix}
                entityId={id}
                entityType={FUND}
              />
            </Grid>

            <Grid item xs={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TopBuys
                    dataId={dataIdPrefix}
                    entityId={id}
                    entityType={FUND}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TopSells
                    dataId={dataIdPrefix}
                    entityId={id}
                    entityType={FUND}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <EntityDeal
                dataId={dataIdPrefix}
                entityType={FUND}
                data={deals}
                onSaveSuccess={onDealSaveSuccess}
              />
            </Grid>

            <Grid item xs={6}>
              <EntityComment
                dataId={dataIdPrefix}
                entity={{
                  entityId: id,
                  entityType: FUND
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <TagInput
            dataId={dataIdPrefix}
            entityId={id}
            entityType={FUND}
          />
        </Grid>

      </Grid>
    </div>
  )
}

FundOverview.propTypes = propTypes
FundOverview.defaultProps = defaultProps

export default memo(FundOverview)
